import { isEmpty, isNull, isUndefined } from 'lodash-es';
import { PERMISSION_ERROR } from './const';
export const defaultErrorMessage = 'Failed to load data';
export function isPermissionError(code) {
    return PERMISSION_ERROR.includes(code);
}
function isInvalid(value) {
    return isUndefined(value) || isNull(value) || isEmpty(value);
}
export function globalRequestInterceptor(config) {
    if (config.isServer) {
        const serverBaseUrl = typeof process !== 'undefined' && process.env ? process.env.baseUrl || process.env.jsUrl || '' : '';
        config.baseURL = `${serverBaseUrl}${config.baseURL}`;
    }
    return config;
}
export function globalResponseInterceptor(response) {
    const { data } = response;
    const config = response.config;
    const errorHandler = config.errorHandler;
    const normalizeError = (code, message, options = {}) => {
        const { status, response: axiosResponse } = options;
        const error = new Error(message);
        error.data = {
            code,
            data: null,
            message,
        };
        if (typeof status === 'number') {
            error.status = status;
        }
        if (axiosResponse) {
            error.response = axiosResponse;
        }
        return error;
    };
    // 204 No Content 是合法的成功响应，允许空响应体
    if (response.status === 204) {
        return Promise.resolve({ code: 0, data: null, message: 'success' });
    }
    if (isInvalid(data)) {
        if (errorHandler?.onBusinessError) {
            errorHandler.onBusinessError({
                code: -1,
                status: response.status,
                response,
                config,
                message: defaultErrorMessage,
            });
        }
        return Promise.reject(normalizeError(-1, defaultErrorMessage, {
            status: response.status,
            response,
        }));
    }
    const responseData = { ...data };
    const allowedCodes = [0, ...(config.allowedCodes || [])];
    if (allowedCodes.includes(responseData.code)) {
        return Promise.resolve(responseData);
    }
    if (isPermissionError(responseData.code)) {
        errorHandler?.onPermissionError?.();
    }
    // 触发业务错误回调
    if (errorHandler?.onBusinessError) {
        errorHandler.onBusinessError({
            code: responseData.code,
            status: response.status,
            response,
            config,
            message: data.message,
            key: data.key,
        });
    }
    return Promise.reject(Object.assign(new Error(data.message || defaultErrorMessage), {
        ...responseData,
        message: data.message || defaultErrorMessage,
    }));
}
export function globalErrorHandlerInterceptor(error) {
    const { message, response } = error;
    const config = error.config;
    const errorHandler = config?.errorHandler;
    if (isInvalid(response)) {
        // 触发 HTTP 错误回调
        if (errorHandler?.onHttpError) {
            errorHandler.onHttpError({
                response: undefined,
                config,
                message: message || defaultErrorMessage,
            });
        }
        return Promise.reject(Object.assign(new Error(defaultErrorMessage), {
            code: -1,
            data: null,
            message: defaultErrorMessage,
        }));
    }
    const { status, data: responseData } = response;
    // HTTP 错误响应体可能不符合 ResponseData 结构，安全解构
    const code = responseData?.code ?? status ?? -1;
    const data = responseData?.data;
    const key = responseData?.key;
    const responseMessage = responseData?.message;
    // 触发 HTTP 错误回调
    if (errorHandler?.onHttpError) {
        errorHandler.onHttpError({
            status,
            code,
            response,
            config,
            message: responseMessage || message || defaultErrorMessage,
            key,
        });
    }
    const errorMessage = message || defaultErrorMessage;
    return Promise.reject(Object.assign(new Error(errorMessage), {
        code,
        data,
        message: errorMessage,
        status,
        response,
    }));
}
